export enum AuthReducerAction {
  SignIn = 'signIn',
  SignOut = 'signOut',
  UpdateProfile = 'updateProfile'
}
